import * as HOME_API from '@/api/home'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    getHomePageAggregatedSums({ commit }) {
      return HOME_API.getAggregatedSums().then(resp => {
        return resp.data
      })
    },
    getHomePageRecenttActivities({ commit }) {
      return HOME_API.getRecenttActivities().then(resp => {
        return resp.data
      })
    }
  }
}
